import * as React from "react";
import Typography from "@mui/material/Typography";
import { Select, MenuItem, Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import Switch from "@mui/material/Switch";
import {
  ENTITY_TYPES,
  MenuProps,
  multiplierOptions,
  multiplierMappings,
  DropdownSx,
} from "../../../utils";
import { display } from "@mui/system";

const SelectionsCount = (props) => {
  const {
    type,
    selectionsArray,
    multiplierEntity = "",
    multiplierValue = "",
    totalCount,
    entityType,
    handleCommonMultiplierChange,
    getItemDetails,
    itemDisplay,
  } = props;
  const getCount = () => {
    if (selectionsArray) {
      return `(${selectionsArray.length}/${totalCount})`;
    } else {
      return `(0/${totalCount})`;
    }
  };

  const handleMultiplierChange = React.useCallback(
    (event) => {
      handleCommonMultiplierChange?.(event?.target?.value, multiplierEntity);
      event.stopPropagation();
    },
    [multiplierEntity, handleCommonMultiplierChange]
  );

  const handleControlClick = React.useCallback((event) => {
    event.stopPropagation();
  }, []);

  const handleDisplayItemToggle = React.useCallback(() => {
    getItemDetails(multiplierEntity);
  }, [getItemDetails, multiplierEntity]);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography sx={{ mx: 1 }}>{getCount()}</Typography>

      {entityType === ENTITY_TYPES.planogram && (
        <>
          <FormControl sx={{ minWidth: 120, m: 0, p: 0 }} size="small">
            <InputLabel>Multiplier</InputLabel>
            <Select
              label="Multiplier"
              value={multiplierValue}
              onChange={handleMultiplierChange}
              onOpen={handleControlClick}
              onClose={handleControlClick}
              MenuProps={MenuProps}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {multiplierOptions.map((option) => (
                <MenuItem sx={DropdownSx} key={option} value={option}>
                  {multiplierMappings[option]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
      {[ENTITY_TYPES.planogram, ENTITY_TYPES.discount].includes(entityType) && (
        <FormControlLabel
          label="Display Item Data"
          labelPlacement="start"
          sx={{ mr: 1, ...(type === "Vendor" && { display: "none" }) }}
          onClick={handleControlClick}
          control={
            <Switch
              size="small"
              checked={itemDisplay}
              onChange={handleDisplayItemToggle}
              onClick={handleControlClick}
            />
          }
        />
      )}
    </Box>
  );
};

export default SelectionsCount;
